import { INTAKE_TYPES } from '@IntakeModule';

export function getIntakeFlags(intakeType: string, shelterProfile: any | null | undefined) {
  const signatureFlags: Record<string, boolean> = {
    [INTAKE_TYPES.BOARDING_IN]: !!shelterProfile?.enable_intake_boarding_in_signature,
    [INTAKE_TYPES.CLINIC_IN]: !!shelterProfile?.enable_intake_clinic_in_signature,
    [INTAKE_TYPES.DOA]: !!shelterProfile?.enable_intake_doa_signature,
    [INTAKE_TYPES.OWNER_REQUESTED_EUTHANASIA]: !!shelterProfile?.enable_intake_owner_requested_euthanasia_signature,
    [INTAKE_TYPES.OWNER_SURRENDER]: !!shelterProfile?.enable_intake_owner_surrender_signature,
    [INTAKE_TYPES.RETURN]: !!shelterProfile?.enable_intake_return_signature,
    [INTAKE_TYPES.SEIZED]: !!shelterProfile?.enable_intake_seized_signature,
    [INTAKE_TYPES.SERVICE_IN]: !!shelterProfile?.enable_intake_service_in_signature,
    [INTAKE_TYPES.STRAY]: !!shelterProfile?.enable_intake_stray_signature,
    [INTAKE_TYPES.TNVR]: !!shelterProfile?.enable_intake_tnvr_signature,
    [INTAKE_TYPES.TRANSFER_IN]: !!shelterProfile?.enable_intake_transfer_in_signature,
    [INTAKE_TYPES.WILDLIFE_IN]: !!shelterProfile?.enable_intake_wildlife_in_signature,
  };

  const paymentFlags: Record<string, boolean> = {
    [INTAKE_TYPES.BOARDING_IN]: !!shelterProfile?.enable_intake_boarding_in_payment,
    [INTAKE_TYPES.CLINIC_IN]: !!shelterProfile?.enable_intake_clinic_in_payment,
    [INTAKE_TYPES.DOA]: !!shelterProfile?.enable_intake_doa_payment,
    [INTAKE_TYPES.OWNER_REQUESTED_EUTHANASIA]: !!shelterProfile?.enable_intake_owner_requested_euthanasia_payment,
    [INTAKE_TYPES.OWNER_SURRENDER]: !!shelterProfile?.enable_intake_owner_surrender_payment,
    [INTAKE_TYPES.RETURN]: !!shelterProfile?.enable_intake_return_payment,
    [INTAKE_TYPES.SEIZED]: !!shelterProfile?.enable_intake_seized_payment,
    [INTAKE_TYPES.SERVICE_IN]: !!shelterProfile?.enable_intake_service_in_payment,
    [INTAKE_TYPES.STRAY]: !!shelterProfile?.enable_intake_stray_payment,
    [INTAKE_TYPES.TNVR]: !!shelterProfile?.enable_intake_tnvr_payment,
    [INTAKE_TYPES.TRANSFER_IN]: !!shelterProfile?.enable_intake_transfer_in_payment,
    [INTAKE_TYPES.WILDLIFE_IN]: !!shelterProfile?.enable_intake_wildlife_in_payment,
  };

  return {
    signature: signatureFlags[intakeType] ?? false,
    payment: paymentFlags[intakeType] ?? false,
  };
}
